import { useNavigate } from "react-router-dom";
import { EmptyState } from "../components/Bits";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <EmptyState
      title="Nothing here"
      body="This page doesn't exist, or your role can't open it."
      action={
        <button className="btn-sharp btn-secondary" onClick={() => navigate("/")}>
          Back to overview
        </button>
      }
    />
  );
}
